
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beneficios",
      function () {
        return require("private-next-pages/beneficios.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beneficios"])
      });
    }
  